export const Registration = {
  PRODUCER_CREATE_OR_UPDATE: 'PRODUCER_CREATE_OR_UPDATE'
}
